import BaseService from "src/packages/BaseService";

export default class PassportService extends BaseService {
	static get className () {
		return "oauth/clients";
	}

	static remove (id, dataUrl = {}) {
		dataUrl._method = "delete";
		return BaseService.getService().post(this.className + "/" + id, dataUrl).then(
			response => {
				if (response.data) {
					return response.data;
				} else {
					throw new Error(response.data);
				}
			},
		);
	}
};
